// js
import React from 'react';
import SecurityDetail from '../SecurityDetail';


const SecurityDetailPPTX = props => (
  <SecurityDetail
    {...props}
    categoryCorrelationsLimit={6}
    showAdditionalCounts
  />
);

export default SecurityDetailPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/SecurityDetailPPTX.js